import React, { useEffect, useState } from "react";
import { styleSheet } from "./style";
import { withStyles } from "@mui/styles";
import { Box, Stack, Card, Typography, Skeleton, Paper, Chip } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import shield1 from "../../../assets/images/shield1.png";
import shield2 from "../../../assets/images/shield2.png";
import shield3 from "../../../assets/images/shield3.png";
import shield4 from "../../../assets/images/shield4.png";
import PointsHistory from "./pointsHistory";
import { useSelector } from "react-redux";
import { CustomTooltip } from "../../../components/shared/tooltip";
import { useNavigate } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';

function AgentPoints(props) {
  let { classes, adminDetail } = props;
  const [rank, setRank] = useState("-");
  const navigate = useNavigate();
  const pointsData = useSelector(
    (state) => state.agentRoster.points.pointsData
  );
  useEffect(() => {
    if (pointsData?.leaderboard?.length && adminDetail.id) {
      let newPoints = [...pointsData.leaderboard];
      let newLeaderboard = newPoints.sort((a, b) => b.point - a.point);
      let newPointsWithRank = [];
      let rankNumber = 0;
      newLeaderboard.map((item, index) => {
        if (index === 0) {
          newPointsWithRank.push({ ...item, rank: 1 });
          rankNumber = rankNumber + 1;
        } else {
          if (item.point === newLeaderboard[index - 1].point) {
            newPointsWithRank.push({ ...item, rank: rankNumber });
          } else {
            rankNumber = rankNumber + 1;
            newPointsWithRank.push({ ...item, rank: rankNumber });
          }
        }
      });
      setRank(
        newPointsWithRank.find((item) => item.user_id == adminDetail.id)
          ?.rank || "-"
      );
    }
  }, [pointsData?.leaderboard, adminDetail.id]);
  return (
    <Paper elevation={2} className={`${classes.pointsTabRoot} dashboard-points-paper`} style={{
      background: "rgba(255,255,255,0.8)",
      boxShadow: "0px 10px 50px 0px rgba(0,0,0,0.03)",
      border: "none",
      borderRadius: "18px",
      marginTop: '0px',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    }}>
      <Box sx={{ padding: '24px 24px 0 24px', pb: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, mb: 0, mt: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{ width: 40, height: 40, borderRadius: '50%', background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <StarIcon sx={{ color: '#fff', fontSize: 22 }} />
            </Box>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 500, fontSize: 18, color: '#111', lineHeight: 1, mb: 0.875 }}>Points</Typography>
              <Typography variant="subtitle1" sx={{ color: '#888', fontSize: 15, fontWeight: 400, lineHeight: 1, mt: 0 }}>Point activity and monthly ranking</Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Tooltip
              title="Point balance resets monthly."
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                    padding: '8px 12px',
                    maxWidth: 'none',
                    whiteSpace: 'nowrap',
                    background: 'linear-gradient(to right, rgba(100, 100, 100, 0.05), rgba(50, 50, 50, 0.1))',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    color: '#666',
                  }
                }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#ECECEC', borderRadius: '10px', px: 1.25, py: 0.6, fontWeight: 600, fontSize: 15, color: '#111', mr: 1, width: 105 }}>
                <StarIcon sx={{ color: '#111', fontSize: 18 }} />
                <Typography sx={{ fontWeight: 600, fontSize: 18, color: '#111', ml: 2 }}>{pointsData?._metadata?.total_point || "0"}</Typography>
              </Box>
            </Tooltip>
            <Tooltip
              title="Your current month ranking."
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: '14px',
                    padding: '8px 12px',
                    maxWidth: 'none',
                    whiteSpace: 'nowrap',
                    background: 'linear-gradient(to right, rgba(100, 100, 100, 0.05), rgba(50, 50, 50, 0.1))',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    color: '#666',
                  }
                }
              }}
            >
              <Box sx={{ position: 'relative', width: 56, height: 56, display: 'flex', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', mt: '-3.5px', mb: '-3.5px' }}>
                <img
                  src={
                    pointsData?._metadata?.total_point > 0
                      ? rank === "-"
                        ? shield1
                        : rank === 1
                        ? shield3
                        : rank === 2
                        ? shield4
                        : rank === 3
                        ? shield2
                        : shield1
                      : shield1
                  }
                  alt="point shield"
                  style={{ width: 51, height: 51 }}
                />
                <Box sx={{ position: 'absolute', left: '50%', top: '46%', transform: 'translate(-50%, -50%)', color: '#fff', fontWeight: 700, fontSize: 16 }}>
                  {pointsData?._metadata?.total_point > 0 ? rank : "-"}
                </Box>
              </Box>
            </Tooltip>
          </Box>
        </Box>
      </Box>
      <PointsHistory adminDetail={adminDetail} {...props} />
    </Paper>
  );
}
export default withStyles(styleSheet, {
  name: "AgentPointsStyle",
})(AgentPoints);
